import { rjTriggerApi } from "./config";

const rjTriggerApiWithTag = rjTriggerApi.enhanceEndpoints({
  addTagTypes: ["users-list"],
});

const rjApiSlice = rjTriggerApiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    getIpAddress: builder.query({
      query: () => ({
        url: "/get-advise-ip",
      }),
    }),
    triggerIpAdvice: builder.query({
      query: ({ ipValue, date }) => ({
        url: `/initiate/copy?ipAddress=${ipValue}&copyDate=${date}`,
      }),
    }),
  }),
});

export const { useGetIpAddressQuery, useLazyTriggerIpAdviceQuery } = rjApiSlice;

export default rjApiSlice;
